// src/components/SignupWidget.jsx
import React, { useRef, useState } from "react";
import Turnstile, { TURNSTILE_SITE_KEY } from "./Turnstile";
import { validateSignup, USERNAME_MAX, PASSWORD_MAX, EMAIL_MAX, NAME_MAX, COUNTRY_MAX } from "../helpers/accountRules";

// handleSignup(captchaToken) must return a promise, so the captcha can be refreshed once the attempt finishes.
export default function SignupWidget({ signupData, setSignupData, handleSignup, setShowSignup, onShowPrivacy, message,onShowTerms }) {
  const [agree, setAgree] = useState(false);
  const [termsagree, setTermsAgree] = useState(false);
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);
  const captcha = useRef(null);

  const [problem, setProblem] = useState("");

  // same rules the server applies (src/helpers/accountRules.js), so mistakes show up before anything is sent
  const field = (key, placeholder, type = "text", extra = {}) => (
    <input
      type={type}
      placeholder={placeholder}
      value={signupData[key]}
      onChange={(e) => { setProblem(""); setSignupData({ ...signupData, [key]: e.target.value }); }}
      {...extra}
    />
  );

  const needsCaptcha = !!TURNSTILE_SITE_KEY;
  const ready = agree && termsagree && !busy && (!needsCaptcha || !!token);

  const submit = async () => {
    const check = validateSignup(signupData);
    if (check.error) return setProblem(check.error);
    setProblem("");
    setBusy(true);
    try {
      await handleSignup(token);
    } finally {
      setBusy(false);
      setToken("");
      captcha.current?.reset(); // a captcha token only works once
    }
  };

  return (
    <div className="overlay-widget">
      <h2>Signup</h2>
      {field("username", "Username (letters, numbers, . _ -)", "text", { maxLength: USERNAME_MAX, autoComplete: "username", autoCapitalize: "none", spellCheck: false })}
      {field("password", "Password (8+ characters)", "password", { maxLength: PASSWORD_MAX, autoComplete: "new-password" })}
      {field("email", "Email", "email", { maxLength: EMAIL_MAX, autoComplete: "email" })}
      {field("name", "Name", "text", { maxLength: NAME_MAX, autoComplete: "name" })}
      {field("country", "Country", "text", { maxLength: COUNTRY_MAX, autoComplete: "country-name" })}
      <label className="consent-row">
        <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
        <span>
          I've read and agree to the{" "}
          <a href="/privacy" onClick={(e) => { e.preventDefault(); onShowPrivacy(); }}>Privacy Policy</a>.
        </span>
        <input type="checkbox" checked={termsagree} onChange={(a) => setTermsAgree(a.target.checked)} />
        <span>
          I've read and agree to the{" "}
          <a href="/terms" onClick={(a) => { a.preventDefault(); onShowTerms(); }}>Terms and Conditions</a>.
        </span>
      </label>
      <Turnstile ref={captcha} onToken={setToken} />
      <button onClick={submit} disabled={!ready} style={!ready ? { opacity: 0.5, cursor: "not-allowed" } : undefined}>
        {busy ? "Creating account…" : "Submit"}
      </button>
      <button onClick={() => setShowSignup(false)}>Close</button>
      {(problem || message) && <p>{problem || message}</p>}
    </div>
  );
}
